import { AuthActions } from "../actions";

const initialState = {
  authenticated: null,
  me: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case AuthActions.ACTION_AUTH_AUTHENTICATE:
      return {
        ...state,
        authenticated: action.payload,
      };
    case AuthActions.ACTION_AUTH_ME:
      return {
        ...state,
        me: action.payload,
      };
    case AuthActions.ACTION_AUTH_RECOVERY:
      return {
        ...state,
        recover: action.payload,
      };
    default:
      return state;
  }
};

export function isAuthenticated(state) {
  return state.auth.authenticated;
}

export function getMe(state) {
  return state.auth.me;
}

export function getData(state) {
  return state.auth;
}

export function getProfileType(state) {
  return state.auth.me?.profileType;
}

export function getManagerContract(state) {
  return state.auth.me?.managerContract;
}
